import React from 'react';
import { View, Platform, Text } from 'react-native';

// Import conditionnel de WebView seulement sur mobile
let WebView: any = null;
if (Platform.OS !== 'web') {
  WebView = require('react-native-webview').WebView;
}

interface UniversalWebViewProps {
  source: { uri: string };
  style?: any;
  renderLoading?: () => React.ReactElement;
  onError?: (event: any) => void;
  onHttpError?: (event: any) => void;
  onMessage?: (event: any) => void;
  javaScriptEnabled?: boolean;
  domStorageEnabled?: boolean;
  startInLoadingState?: boolean;
  scalesPageToFit?: boolean;
  injectedJavaScript?: string;
}

const UniversalWebView: React.FC<UniversalWebViewProps> = ({
  source,
  style,
  renderLoading,
  onError,
  onHttpError,
  onMessage,
  javaScriptEnabled = true,
  domStorageEnabled = true,
  startInLoadingState = true,
  scalesPageToFit = true,
  injectedJavaScript,
  ...props
}) => {
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(false);

  const handleLoad = () => {
    setLoading(false);
  };

  const handleError = () => {
    setLoading(false);
    setError(true);
    if (onError) {
      onError({ nativeEvent: { description: 'Failed to load webpage' } });
    }
  };

  if (Platform.OS === 'web') {
    return (
      <View style={[{ position: 'relative', flex: 1 }, style]}>
        {loading && renderLoading && renderLoading()}
        {error ? (
          <View style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            padding: 20
          }}>
            <Text>Erreur lors du chargement de la page</Text>
            <Text 
              style={{ color: 'blue', textDecorationLine: 'underline', marginTop: 10 }}
              onPress={() => window?.open(source.uri, '_blank')}
            >
              Ouvrir dans un nouvel onglet
            </Text>
          </View>
        ) : (
          <iframe
            src={source.uri}
            style={{
                
              width: '100%',
              height: '100%',
              border: 'none',
              display: loading ? 'none' : 'block'
            }}
            onLoad={handleLoad}
            onError={handleError}
            title="WebView Content"
            {...props}
          />
        )}
      </View>
    );
  }

  // Mobile (React Native)
  return (
    <View style={[{ flex: 1 }, style]}>
      <WebView
        source={source}
        style={{ flex: 1 }}
        javaScriptEnabled={javaScriptEnabled}
        domStorageEnabled={domStorageEnabled}
        startInLoadingState={startInLoadingState}
        scalesPageToFit={scalesPageToFit}
        renderLoading={renderLoading}
        onError={onError}
        onHttpError={onHttpError}
        onMessage={onMessage}
        injectedJavaScript={injectedJavaScript}
        {...props}
      />
    </View>
  );
};

export { UniversalWebView };
export default UniversalWebView;